/**
 * Coups de pouce — attendu 622 (égalités à trou multiplicatives).
 *
 * Routage par generator_key. Exemples HORS pools : a = 32 et a = 33
 * dépassent le plafond de tirage (a ≤ 30 sur ces formats).
 */

// Compléter b × ? = a par la PROPRIÉTÉ (pas de placement spatial,
// retour user) : question → « le quotient de 32 par 5 » → son écriture
// 32/5 (les couleurs montrent où atterrit chaque nombre) → vérification.
const SVG_TROU = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 160" width="290" height="155" role="img" data-etapes="4"
     aria-label="On complète : 5 fois quel nombre égale 32 ? La propriété de la leçon répond : ce nombre, c’est le quotient de 32 par 5. Il s’écrit 32 sur 5, en fraction. Vérification : 5 fois 32 cinquièmes égale 32, ça marche">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp622trou 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp622trouc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp622trou 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp622trouc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp622trou 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp622trouc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp622trou 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp622troucf 8s linear infinite 6s; }
    }
    @keyframes cp622trou { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp622trouc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp622troucf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <text x="112" y="30" text-anchor="middle" font-size="15" font-weight="bold" fill="#b45309">5</text>
  <text x="129" y="30" text-anchor="middle" font-size="14" fill="#334155">×</text>
  <rect x="140" y="15" width="18" height="20" fill="none" stroke="#94a3b8" stroke-width="1.2"/>
  <text x="149" y="30" text-anchor="middle" font-size="14" font-weight="bold" fill="#334155">?</text>
  <text x="167" y="30" text-anchor="middle" font-size="14" fill="#334155">=</text>
  <text x="188" y="30" text-anchor="middle" font-size="15" font-weight="bold" fill="#f97316">32</text>
  <g class="anim d1" data-etape="1">
    <rect x="138" y="13" width="22" height="24" fill="#fed7aa" fill-opacity="0.45" stroke="#f97316" stroke-width="2"/>
  </g>
  <g class="anim d2" data-etape="2">
    <text x="150" y="68" text-anchor="middle" font-size="12.5" fill="#334155">c’est <tspan font-weight="bold">le quotient</tspan> de <tspan font-weight="bold" fill="#f97316">32</tspan> par <tspan font-weight="bold" fill="#b45309">5</tspan></text>
  </g>
  <g class="anim d3" data-etape="3">
    <text x="128" y="100" text-anchor="end" font-size="12" fill="#334155">il s’écrit</text>
    <text x="146" y="94" text-anchor="middle" font-size="12" font-weight="bold" fill="#f97316">32</text>
    <line x1="137" y1="98" x2="155" y2="98" stroke="#334155" stroke-width="1.4"/>
    <text x="146" y="110" text-anchor="middle" font-size="12" font-weight="bold" fill="#b45309">5</text>
  </g>
  <g class="anim d4" data-etape="4">
    <text x="118" y="133" text-anchor="end" font-size="12" font-weight="bold" fill="#b45309">5 ×</text>
    <text x="132" y="126" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">32</text>
    <line x1="124" y1="129.5" x2="140" y2="129.5" stroke="#334155" stroke-width="1.1"/>
    <text x="132" y="139" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">5</text>
    <text x="146" y="133" font-size="12" font-weight="bold" fill="#0f172a">= 32 ✓</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="152" text-anchor="middle" font-size="11.5" fill="#334155">quel nombre, multiplié par <tspan font-weight="bold" fill="#b45309">5</tspan>, donne <tspan font-weight="bold" fill="#f97316">32</tspan> ?</text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="152" text-anchor="middle" font-size="11.5" fill="#334155">c’est <tspan font-weight="bold">la propriété de la leçon</tspan> !</text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="152" text-anchor="middle" font-size="11.5" fill="#334155">le quotient de 32 par 5 s’écrit <tspan font-weight="bold">en fraction</tspan></text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="152" text-anchor="middle" font-size="11.5" fill="#334155">vérifie : on retombe bien sur <tspan font-weight="bold" fill="#f97316">32</tspan> !</text>
  </g>
</svg>`.trim();

const FICHE_TROU = {
    pages: [
        {
            titre: 'Trouver la fraction manquante',
            lignes: [
                'Tu cherches **le nombre qui, multiplié par 5, donne 32**.',
                'C\'est la propriété de la leçon : ce nombre, c\'est **le quotient** $\\dfrac{32}{5}$ !',
            ],
            svg: SVG_TROU,
        },
        {
            titre: 'Dans l\'autre sens',
            lignes: [
                'Même règle quand le trou est devant : $? \\times 4 = 33$.',
                'Le nombre qui, multiplié par 4, donne 33, c\'est **le quotient de 33 par 4** : $\\dfrac{33}{4}$.',
                'La multiplication est **commutative** : $? \\times 4$ ou $4 \\times ?$, c\'est le même produit.',
            ],
        },
    ],
};

// Le numérateur manquant quand le dénominateur est déjà là (b × ?/b = a) :
// même raisonnement de propriété, sobre — le geste est plus court.
// Exemple hors pool : a = 31 > 30.
const FICHE_NUM = {
    pages: [
        {
            titre: 'Le numérateur manquant',
            lignes: [
                'Exemple : $7 \\times \\dfrac{\\;?\\;}{7} = 31$.',
                'La propriété de la leçon : **le quotient de 31 par 7, multiplié par 7, redonne 31**.',
                'Le numérateur cherché, c\'est donc **le résultat : 31**. Vérifie : $7 \\times \\dfrac{31}{7} = 31$ ✓',
            ],
        },
    ],
};

// Relier calcul ↔ résultat : les deux chemins de vérification (arbitrage
// user : propriété OU multiplication classique). Exemple p1 hors pool
// (15 > 12, plafond du format) ; p2 = le cas fraction affichée simplifiée.
const FICHE_DEUX_CHEMINS = {
    pages: [
        {
            titre: 'Le chemin rapide : la propriété',
            lignes: [
                'Quand le nombre qui multiplie est **le même** que le dénominateur, la propriété répond directement :',
                '$15 \\times \\dfrac{7}{15} = 7$',
                'C\'est la propriété de la leçon : $b \\times \\dfrac{a}{b} = a$',
            ],
        },
        {
            titre: 'Sinon : multiplie, puis divise',
            lignes: [
                'Dans $6 \\times \\dfrac{2}{3}$, le 6 et le 3 ne sont pas les mêmes : là, on calcule.',
                '**6 × 2 = 12**, puis **12 ÷ 3 = 4** : donc $6 \\times \\dfrac{2}{3} = 4$.',
            ],
        },
    ],
};

const CP_622 = {
    egalite_mult_trou_saisie: FICHE_TROU,
    egalite_mult_qcm: FICHE_TROU,
    egalite_num_mult_texte: FICHE_NUM,
    fraction_inconnue_trou_saisie: FICHE_NUM,
    produit_mult_relier: FICHE_DEUX_CHEMINS,
};

export default CP_622;
